
function FourthSection() {
    return (
      <div className='w-full h-full pt-14 bg-darkerBlue flex flex-col items-center px-14 text-center'>
        <div className='w-full max-w-2xl mb-8'>
          <p className='text-3xl font-bold text-primaryBlack'>See How the App Works</p>
          <p className='text-lg text-primaryBlack mt-2'>Watch this quick demo to get started effortlessly.</p>
        </div>

        <div className='w-full flex justify-center'>
          <video className='w-full max-w-3xl rounded-lg shadow-lg' controls>
            <source src='https://greetlych.fra1.cdn.digitaloceanspaces.com/Purple%20Modern%20How%20To%20Install%20App%20Video-2.mp4' type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    );
}

export default FourthSection;
